import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { adsService } from '../services/ads.service';
import { getApiErrorMessage } from '@/lib/utils/api-errors';

export function useCampaignStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ refId, status }: { refId: string; status: 'active' | 'paused' }) =>
      adsService.updateCampaignStatus(refId, status),
    onSuccess: (_, { refId }) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', refId] });
      toast.success('Statut de la campagne mis à jour');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}
